import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement

// DOMPurify (npm) — sanitizace HTML z CMS editoru při renderu. Obsah píše jen admin, ale i tak
// se renderuje přes allowlist (defense in depth). Převzato z bowlingligy (RichText.kt).
external interface DomPurify {
    fun sanitize(dirty: String, config: dynamic = definedExternally): String
}

@JsModule("dompurify")
@JsNonModule
external val DOMPurify: DomPurify

// Pozn.: execCommand('bold'/'italic') generuje <b>/<i> (ne <strong>/<em>) -> musí být v allowlistu,
// jinak je dompurify při renderu strhne a zvýraznění "nefunguje".
private val sanitizeConfig: dynamic = js(
    """({
        ALLOWED_TAGS: ['h2','h3','h4','p','br','b','strong','i','em','u','s','ul','ol','li','blockquote','a'],
        ALLOWED_ATTR: ['href','target','rel','title']
    })"""
)

fun sanitizeHtml(html: String): String = DOMPurify.sanitize(html, sanitizeConfig)

/** Vykreslí sanitizované CMS HTML do kontejneru. Přesanitizuje při každé změně `html`. */
@Composable
fun RichContent(html: String) {
    Div(attrs = { classes("rich-content") }) {
        DisposableRefEffect(html) { element ->
            (element as HTMLElement).innerHTML = sanitizeHtml(html)
            onDispose { element.innerHTML = "" }
        }
    }
}
